import { Card, Text, useMantineTheme } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export default function AddressLevel() {
  const tBooking = useTranslations('booking');
  const theme = useMantineTheme();

  const { control, setValue, getValues } = useFormContext();

  const ADDRESS_LEVELS = [
    { value: '1', label: tBooking('location.frontage') },
    { value: '2', label: tBooking('location.parking_lot') },
    { value: '3', label: tBooking('location.2_meter_alley') },
    { value: '4', label: tBooking('location.3_meter_alley') },
    { value: '5', label: tBooking('location.car_alley') },
  ];

  const [selectedLevel, setSelectedLevel] = useState<string | undefined>(
    getValues('level')
  );

  const handleSelectSlide = useCallback((index: string | undefined) => {
    if (!index) {
      setSelectedLevel('');
      return;
    }
    setSelectedLevel(index);
    setValue('level', index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      name="level"
      control={control}
      render={() => (
        <>
          {ADDRESS_LEVELS.map((level) => (
            <Card
              key={level.value}
              withBorder
              radius={16}
              px={8}
              py={4}
              style={{
                cursor: 'pointer',
                backgroundColor:
                  selectedLevel === level.value
                    ? theme.colors.primary[1]
                    : 'white',

                borderColor:
                  selectedLevel === level.value
                    ? theme.colors.primary[6]
                    : theme.colors.neutral[3],
              }}
              onClick={() => {
                if (selectedLevel === level.value) {
                  handleSelectSlide(undefined);
                } else {
                  handleSelectSlide(level.value);
                }
              }}
            >
              <Text
                size="sm"
                fw={600}
                style={{ whiteSpace: 'nowrap' }}
                c={selectedLevel === level.value ? 'primary.5' : 'neutral.7'}
              >
                {level.label}
              </Text>
            </Card>
          ))}
        </>
      )}
    />
  );
}
